import { LAST_GROUPS_KEY } from "../components/Groups/constants/groupsConsts";
import { useLocalStorageValue } from "./useLocalStorage";

export const useGroupId = () => {
  return useLocalStorageValue(LAST_GROUPS_KEY);
};
